import { leagueEntriesResponseSchema } from "../../schemas/leagues";
import { fetchApi, fetchVoid } from "../internal";

export const entries = {
	list: (leagueId: string, seasonId?: string) => {
		const searchParams = new URLSearchParams();
		if (seasonId) searchParams.set("season_id", seasonId);
		const qs = searchParams.toString();
		return fetchApi(
			`/leagues/${leagueId}/entries${qs ? `?${qs}` : ""}`,
			leagueEntriesResponseSchema,
		);
	},
	// Staff removing another member. Self-withdraw (`me`) is a mobile-only path.
	remove: (leagueId: string, userId: string) =>
		fetchVoid(`/leagues/${leagueId}/entries/${userId}`, { method: "DELETE" }),
};
